// src/components/auth/RequireAdminRole.tsx
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/lib/hooks/useMe';
import type { AxiosError } from 'axios';

interface Props {
  children: ReactNode;
}

export const RequireAdminRole = ({ children }: Props) => {
  const { data: me, isLoading, isError, error } = useMe();

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Caricamento…</div>;
  }
  if (isError) {
    const status = (error as AxiosError | undefined)?.response?.status;
    // 401 → not authenticated, send to login
    if (status === 401) return <Navigate to="/login" replace />;
    // Other errors → show error UI without losing the session
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="rounded-lg border border-destructive/50 bg-destructive/10 px-6 py-4 text-sm text-destructive max-w-md">
          Errore nel caricamento del profilo utente{status ? ` (HTTP ${status})` : ''}. Riprova più tardi.
        </div>
      </div>
    );
  }
  if (!me) return <Navigate to="/login" replace />;
  if (me.role === 'user') return <Navigate to="/chat" replace />;
  return <>{children}</>;
};
